<template>
    <div class="container-fluid">
    <br />
    <b-row>
      <b-col class="col-sm-12">
        <Spinner v-if="loadingData" />
        <div class="card" v-for="(admin, index) in dailyInfoByAdmin" :key="index">
          <div class="card-header">
            <i class="fa fa-user"></i> {{admin.description}}
          </div>
          <div class="card-body">
            <div>
              <b-row>
                <b-col class="list-group-item" sm="2">Data</b-col>
                <b-col class="list-group-item" sm="2">Conteúdos de Post</b-col>
                <b-col class="list-group-item" sm="2">Legendas</b-col>
                <b-col class="list-group-item" sm="2">Sleekers</b-col>
                <b-col class="list-group-item" sm="2">Artes</b-col>
              </b-row>
              <b-row  v-for="(item, index) in admin.dailyInfoByAdmin" v-bind:key="index">
                <b-col class="list-group-item" sm="2">{{item.date| moment("DD/MM/YYYY")}}</b-col>
                <b-col class="list-group-item" sm="2">{{item.content}}</b-col>
                <b-col class="list-group-item" sm="2">{{item.subtitle}}</b-col>
                <b-col class="list-group-item" sm="2">{{item.sleeker}}</b-col>
                <b-col class="list-group-item" sm="2">{{item.art}}</b-col>
              </b-row>  
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <br />
  </div>
</template>

<script>
import service from "../service";
import Spinner from "./Spinner";

export default {
  name: 'CreationProductivity',
  data: () => {
    return {
      loadingData: true,
      dailyInfoByAdmin: []
    };
  },
  methods: {
    getProductivityByAdmin: function() {
      this.loadingData = true;
      service.getProductivityByAdmin().then(response => {
        this.dailyInfoByAdmin = [];

        let productivityByAdmin = response.productivityByAdmin;

        for (let keyAdmin in productivityByAdmin) {
          let dailyInfo = productivityByAdmin[keyAdmin].creationActionsByDate;
          console.log(dailyInfo);
          let dailyInfoByAdmin = [];

          for (let key in dailyInfo[0]) {
            dailyInfoByAdmin.push({date: dailyInfo[0][key].date, content: dailyInfo[0][key].amount, subtitle: dailyInfo[1][key].amount, sleeker: dailyInfo[2][key].amount, art: dailyInfo[3][key].amount});
          }

          this.dailyInfoByAdmin.push({dailyInfoByAdmin: dailyInfoByAdmin, description: productivityByAdmin[keyAdmin].description});
        }

        console.log(this.dailyInfoByAdmin);

        this.loadingData = false;

        setTimeout(() => {
          this.getProductivityByAdmin();
        }, 1200000);
      });
    },
    getActionDescriptionByType: function(type) {
      let description = "";

      switch(type) {
        case 0:
          description = "definiu o conteúdo neste item: "
        break;
        case 1:
          description = "criou uma legenda neste item: "
        break;
        case 2:
          description = "cadastrou um Sleeker "
        break;
        case 3:
          description = "cadastrou um PSD neste item: "
        break;
      }

      return description;
    }
  },
  created() {
    this.getProductivityByAdmin();
  },
  components: { Spinner }
}
</script>


